import React from 'react'
import Carousel from 'react-multi-carousel'
import { createUseStyles } from 'react-jss'

import { isClientSide } from '../ui/Common/utils'
import SVG from '../ui/SVG/SVG'
import ButtonCta from './atoms/ButtonCta'
import CompTitle from './atoms/CompTitle'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  wrapperDesign: {
    ...theme.wrappers.standard,
  },
  carouselCustomArrowsLeft: {
    textAlign: 'center',
    paddingRight: 9,
    borderRadius: '50%',
    backgroundColor: theme.colors.blue,
    height: 30,
    width: 30,
    zIndex: 1,
    position: 'absolute',
    cursor: 'pointer',
    pointerEvents: 'all',
    boxShadow: 'none',
    border: 'none',
    textShadow: 'none',
    margin: '-2em',
    top: 'calc(50% - 23px)',
    left: 20,
    fill: theme.colors.white,
    color: theme.colors.white,
    '&:hover': {
      fill: theme.colors.white,
      color: theme.colors.white,
      backgroundColor: theme.colors.mainHover,
    },
    '&:active, &:focus': {
      backgroundColor: theme.colors.mainHover,
    },

    '@media (max-width: 1485px)': {
      left: 25,
    },

    '@media (max-width: 600px)': {
      // display: 'none',
      left: 5,
      padding: 0,
      margin: 0,
    },

    '& svg': {
      transform: 'rotate(180deg) scale(0.75)',
      transformOrigin: 'center',
    },
  },
  carouselCustomArrowsRight: {
    paddingLeft: 9,
    textAlign: 'center',
    borderRadius: '50%',
    backgroundColor: theme.colors.blue,
    height: 30,
    width: 30,
    zIndex: 1,
    position: 'absolute',
    cursor: 'pointer',
    pointerEvents: 'all',
    boxShadow: 'none',
    border: 'none',
    textShadow: 'none',
    margin: '-2em',
    top: 'calc(50% - 23px)',
    right: 20,
    fill: theme.colors.white,
    color: theme.colors.white,
    '&:hover': {
      fill: theme.colors.white,
      color: theme.colors.white,
      backgroundColor: theme.colors.mainHover,
    },
    '&:active, &:focus': {
      backgroundColor: theme.colors.mainHover,
    },

    '@media (max-width: 1485px)': {
      right: 25,
    },
    '@media (max-width: 600px)': {
      right: 5,
      padding: 0,
      margin: 0,
    },
    '& svg': {
      transform: 'scale(0.75)',
      transformOrigin: 'center',
    },
  },
  popularSection: {
    fontFamily: theme.fontFamily,
    paddingBottom: 75,
    paddingTop: 85,

    '@media (max-width: 600px)': {
      paddingBottom: 40,
      paddingTop: 35,
    },
    '& .react-multi-carousel-list': {
      paddingBottom: 50,
    },
    '& .react-multi-carousel-dot button': {
      backgroundColor: theme.colors.cloudyBlue,
      border: 'none',
      width: 7,
      height: 7,
    },
    '& .react-multi-carousel-dot--active button': {
      backgroundColor: theme.colors.blue,
    },
    '& img': {
      // width: '100%'
    },
  },
  popularCarouselWrapper: {
    position: 'relative',
  },
  carouselCustomArrows: {
    top: 0,
    position: 'absolute',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
  },
  popularCarousel: {
    margin: '50px 0 25px 0',
    '@media (max-width: 900px)': {
      margin: '35px 0 15px',
    },

    '& .carousel .slide': {
      backgroundColor: 'transparent',
      textAlign: 'left',
    },
    '& .carousel.carousel-slider': {
      overflow: 'visible',
    },
    '& .carousel .control-dots': {
      bottom: '-38px',
      paddingLeft: 0,
    },
    '& .carousel .control-dots .dot': {
      backgroundColor: '#bbcad8',
      boxShadow: 'none',
      opacity: 0.7,
      transition: `background-color 250ms ${theme.animations.bezier}, opacity 250ms ${theme.animations.bezier}`,
    },
    '& .carousel .control-dots .dot.selected': {
      backgroundColor: theme.colors.blue,
      opacity: 1,
    },
    '& .carousel .control-dots .dot:hover': {
      backgroundColor: theme.colors.blue,
      opacity: 1,
    },
  },

  cardHolder: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 12.5px',
  },

  populCarTitle: {
    color: theme.colors.ocean,
    fontSize: 30,
    fontWeight: 900,
    letterSpacing: '1.5px',
    lineHeight: '27px',
    marginBottom: 21,
    marginTop: 0,
    textAlign: 'center',
    textTransform: 'uppercase',

    '@media (max-width: 600px)': {
      fontSize: 24,
      letterSpacing: '0.96px',
      lineHeight: 1.13,
      marginBottom: 25,
    },
  },

  seeAllWrapper: {
    padding: 0,
    // textAlign: 'right',
    textAlign: 'center',
    // margin: '-70px 80px 0',
    margin: '-20px 80px 0',

    '@media (max-width: 900px)': {
      margin: '-20px 0 0',
      // textAlign: 'center',
    },

    '& a': {
      // color: theme.colors.blue,
      fontFamily: theme.fontFamily,
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: '1px',
      lineHeight: '19px',
    },
  },

  containerVT: {
    padding: '45px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1220px',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '45px 15px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
      padding: '45px 15px',
    },
  },

  VTimg: {
    objectFit: 'cover',
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '20px',
    verticalAlign: 'bottom',
  },
  VTSliderTitle: {
    fontSize: '25px',
    lineHeight: '30px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'left',
    paddingTop: '15px',
    paddingBottom: '2px',
    '& a': {
      textDecoration: 'none',
      color: '#007AC3',
    },
  },
  VTSliderTitleSmall: {
    fontSize: '18px',
    lineHeight: '22px',
  },
  VTSliderDetails: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 400,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'left',
    '& a': {
      textDecoration: 'none',
      color: '#2D2D2D',
    },
  },
  VTSliderDetailsSmall: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  VTbtnCont: {
    textAlign: 'center',
    paddingTop: '60px',
  },
  boxShadowStuff: {
    boxSizing: 'border-box',
    height: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '1px 5px 10px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      boxShadow: '1px 5px 10px rgba(0, 0, 0, 0.35)',
    },
  },
}))

const ButtonGroup = ({ next, previous, ...rest }) => {
  const classes = useStyles()
  return (
    <div className={classes.carouselCustomArrows}>
      <button className={classes.carouselCustomArrowsLeft} onClick={() => previous()}>
        <SVG name={'Chevron'} width={14} height={30} />
      </button>
      <button className={classes.carouselCustomArrowsRight} onClick={() => next()}>
        <SVG name={'Chevron'} width={14} height={30} />
      </button>
    </div>
  )
}

const MiniSlider = props => {
  const classes = useStyles()

  const { title, items, linkText, linkURL, title_align, smallerText, blogpost } = props

  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: 1024 },
      items: 4,
    },
    desktopSmall: {
      breakpoint: { max: 1200, min: 1024 },
      items: 4,
    },
    tabletLandscape: {
      breakpoint: { max: 1024, min: 770 },
      items: 3,
    },
    tabletPortait: {
      breakpoint: { max: 769, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  }

  const objArr = obj2Arr(items)

  return (
    <div className={classes.containerVT}>
      <CompTitle text={title} align={title_align} />

      <div style={{ position: 'relative' }}>
        <Carousel
          className={classes.popularCarousel}
          deviceType={isClientSide() ? null : 'desktop'}
          infinite={items.length > 1 && !blogpost}
          arrows={false}
          showDots={false}
          responsive={responsive}
          ssr={true}
          autoPlay={true}
          autoPlaySpeed={4000}
          renderButtonGroupOutside={true}
          customButtonGroup={<ButtonGroup />}
        >
          {objArr &&
            objArr.map(section => {
              const abostyle = blogpost
                ? {}
                : {
                    textAlign: 'center',
                    height: 0,
                    width: '100%',
                    paddingBottom: '100%',
                    position: 'relative',
                  }
              return (
                <div style={{ margin: '0 10px' }} key={section.title}>
                  <div
                    className={classes.boxShadowStuff}
                    style={{
                      backgroundImage: 'linear-gradient(to bottom, #e1e1e1 , #fff)',
                      ...abostyle,
                    }}
                  >
                    <a
                      href={section.link}
                      style={
                        blogpost
                          ? {}
                          : {
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '100%',
                              height: '100%',
                            }
                      }
                    >
                      <img src={section.img} alt={section.alt} className={classes.VTimg} />
                    </a>
                  </div>
                  <div
                    className={`${classes.VTSliderTitle} ${
                      smallerText ? classes.VTSliderTitleSmall : ''
                    }`}
                    style={blogpost ? { textAlign: 'left' } : {}}
                  >
                    <a href={section.link}>{section.title}</a>
                  </div>

                  {!blogpost && (
                    <div
                      className={`${classes.VTSliderDetails} ${
                        smallerText ? classes.VTSliderDetailsSmall : ''
                      }`}
                    >
                      <a href={section.link}>{section.details}</a>
                    </div>
                  )}
                </div>
              )
            })}
        </Carousel>
      </div>

      {linkText && (
        <div className={classes.VTbtnCont}>
          <ButtonCta text={linkText} url={linkURL} />
        </div>
      )}
    </div>
  )
}

export default MiniSlider
